import BaseApi from './BaseApi'

export default {
  storeAddressStep(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/address-step`, payload)
  },

  storeOrderItems(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/order-items`, payload)
  },
  updateOrderItems(orderItemId, payload) {
    return BaseApi.patch(`/v1/draft-order-items/${orderItemId}`, payload)
  },
  destroyOrderItems(orderItemId, payload) {
    return BaseApi.delete(`/v1/draft-order-items/${orderItemId}`)
  },

  storeAppointmentStep(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/appointment-step`, payload)
  },

  storeLogin(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/login`, payload)
  },
  storeLoginViaVerificationCode(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/login-via-verification-code`, payload)
  },
  destroyLogin(orderId) {
    return BaseApi.delete(`/v1/draft-orders/${orderId}/login`)
  },
  storeRegistration(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/registration`, payload)
  },
  updateMemberships(orderId, payload) {
    return BaseApi.put(`/v1/draft-orders/${orderId}/memberships`, payload)
  },

  storeConfirmationStep(orderId, payload) {
    return BaseApi.post(`/v1/draft-orders/${orderId}/confirmation-step`, payload)
  },

  indexCustomerTeamMemberships(orderId, params) {
    const query = new URLSearchParams()

    query.append('filter[search]', params.search ?? '')
    query.append('filter[customer_team_id]', params.customerTeamId ?? [])
    query.append('per_page', params.perPage ?? '')
    query.append('sort', params.sort ?? '')
    query.append('page', params.page ?? 1)

    return BaseApi.get(`/v1/draft-orders/${orderId}/memberships?${query.toString()}`)
  },

  indexCustomerUsers(orderId, params) {
    const query = new URLSearchParams()

    query.append('filter[search]', params.search ?? '')
    query.append('filter[email_domain]', params.emailDomains ?? [])
    query.append('filter[exclude_ids]', params.excludeIds ?? [])
    query.append('filter[has_active_team_memberships]', params.has_active_team_memberships ?? '')
    query.append('per_page', params.perPage ?? '')
    query.append('sort', params.sort ?? '')
    query.append('page', params.page ?? 1)
    query.append('include', params.include ?? '')

    return BaseApi.get(`/v1/draft-orders/${orderId}/customer-users?${query.toString()}`)
  },

  suggestedCustomerTeamMemberships(orderId) {
    return BaseApi.get(`/v1/draft-orders/${orderId}/suggested-customer-team-memberships`)
  },
}
